import React, { Component } from "react";
import { DatePicker } from "components/support";
import Paper from "material-ui-next/Paper";
import Moment from "moment";
import style from "./style";

class Filter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: props.filters,
      changeIndicator: true
    };
  }

  handleChange({ startDate, endDate }) {
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(prevState => ({
      filters: { ...prevState.filters, ...options }
    }));
  }

  handleClose() {
    const { onChange } = this.props;

    this.setState(
      prevState => ({ changeIndicator: !prevState.changeIndicator }),
      () => onChange(this.state.filters)
    );
  }

  render() {
    const { className } = this.props;
    const { filters } = this.state;
    const { dateFrom, dateTo } = filters;

    return (
      <div className={className}>
        <Paper elevation={1} className="pv-sm">
          <span className="datepicker">
            <DatePicker
              multiple
              noMargin
              modal
              label="Período"
              startDate={dateFrom}
              endDate={dateTo}
              onChange={({ startDate, endDate }) =>
                this.handleChange({ startDate, endDate })
              }
              onClose={() => this.handleClose()}
            />
          </span>
        </Paper>
      </div>
    );
  }
}

export default style(Filter);



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/filter/index.js